import Header from '@/components/feature/Header';
import EducationSection from '@/pages/home/components/EducationSection';
import Footer from '@/components/feature/Footer';

export default function CredentialsPage() {
  return (
    <div className="min-h-screen bg-[#DBCEC5]">
      <Header />
      <div className="pt-20">
        <EducationSection bgClassName="pt-8 pb-8 bg-white" />
      </div>
      <Footer />
    </div>
  );
}